import { STORAGE_KEYS } from 'constants/storageKeys';

export function getHeaders(): HeadersInit {
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN);

  if (!token) {
    return {};
  }

  return {
    Authorization: `${token}`,
    'Content-Type': 'application/json',
    'Accept-Language': JSON.parse(localStorage.getItem(STORAGE_KEYS.LOCALE) || '"ru"'),
  };
}
